module.exports = "/next-static/_next/static/images/hero_image_large-facd49589ed1c690be454ec67c6f8583.png";